import React from "react";
export const InputIcon = () => (React.createElement("span", { className: "lysa-ui-input-icon" },
    React.createElement("svg", { className: "lysa-ui-input-spinner", viewBox: "0 0 50 50" },
        React.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }))));
